import {axios as http} from "@/plugins/http"

export default class Api {
    static telegramDuplicate(postId, channelId) {
        return http.post("/api/v1/post/telegram/duplicate", {
            post_id: postId,
            channel_id: channelId,
        }).then((resp) => {
            return resp.data
        })
    }
}
